import { AuthBrand } from './AuthBrand';
import styles from './signin/signin.module.css';

/** The brand + spinner card the auth pages show while their search params resolve. */
export function AuthLoadingCard() {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <AuthBrand />
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          <div className={styles.spinner}></div>
        </div>
      </div>
    </div>
  );
}
